import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import React from 'react'

export const documentHeading1: NodeRenderer = (node, children) => (
  <h1 className="mb-2 text-230 leading-alternate group-[.is-informational-hero]/hero:!text-background-default laptop:text-[56px] laptop:leading-[68px]">
    {children}
  </h1>
)
